import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a665647"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "[ stickyGalleryDesktop ] row pt-4 pb-9" };
const _hoisted_2 = { class: "col-12" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_image_gallery_desktop_slider = _resolveComponent("image-gallery-desktop-slider");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (_ctx.currentProduct)
                ? (_openBlock(), _createBlock(_component_image_gallery_desktop_slider, { key: 0 }))
                : _createCommentVNode("", true)
        ])
    ]));
}
